// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/diagnostics.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AssignRecordingPolicyRequest, AssignRecordingPolicyResponse, ClaimEnrollmentTokenRequest, ClaimEnrollmentTokenResponse, CompleteRecordingSessionRequest, CompleteRecordingSessionResponse, CreateEnrollmentTokenRequest, CreateEnrollmentTokenResponse, CreateExportJobRequest, CreateExportJobResponse, CreateReplayRequestRequest, CreateReplayRequestResponse, CreateStorageTargetRequest, CreateStorageTargetResponse, GetActivityTimelineRequest, GetActivityTimelineResponse, GetDiagnosticsHealthRequest, GetDiagnosticsHealthResponse, GetEffectivePolicyRequest, GetEffectivePolicyResponse, GetLiveEmployeesRequest, GetLiveEmployeesResponse, GetReplaySegmentsRequest, GetReplaySegmentsResponse, GetSegmentationCursorRequest, GetSegmentationCursorResponse, GetTimeInAppRequest, GetTimeInAppResponse, HybridSearchRequest, HybridSearchResponse, ListActivityObservationsRequest, ListActivityObservationsResponse, ListActivitySegmentsRequest, ListActivitySegmentsResponse, ListDeviceEnrollmentsRequest, ListDeviceEnrollmentsResponse, ListEnrollmentTokensRequest, ListEnrollmentTokensResponse, ListExportJobsRequest, ListExportJobsResponse, ListRecordingPoliciesRequest, ListRecordingPoliciesResponse, ListRecordingSessionsRequest, ListRecordingSessionsResponse, ListReplayRequestsRequest, ListReplayRequestsResponse, ListStorageTargetsRequest, ListStorageTargetsResponse, ListWorkspaceActivityRequest, ListWorkspaceActivityResponse, NaturalLanguageSearchRequest, NaturalLanguageSearchResponse, ReaggregateSessionRequest, ReaggregateSessionResponse, RegisterDiagnosticsDeviceRequest, RegisterDiagnosticsDeviceResponse, ReportRecordingHeartbeatRequest, ReportRecordingHeartbeatResponse, ResetSegmentationCursorRequest, ResetSegmentationCursorResponse, RunBatchEmbeddingRequest, RunBatchEmbeddingResponse, SearchTimelineSegmentsRequest, SearchTimelineSegmentsResponse, StartRecordingSessionRequest, StartRecordingSessionResponse, UpdateReplayRequestStatusRequest, UpdateReplayRequestStatusResponse, UploadRecordingArtifactRequest, UploadRecordingArtifactResponse, UpsertRecordingPolicyRequest, UpsertRecordingPolicyResponse, VisualSimilaritySearchRequest, VisualSimilaritySearchResponse } from "./diagnostics_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.DiagnosticsService
 */
export const DiagnosticsService = {
  typeName: "omnios.v1.DiagnosticsService",
  methods: {
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.CreateEnrollmentToken
     */
    createEnrollmentToken: {
      name: "CreateEnrollmentToken",
      I: CreateEnrollmentTokenRequest,
      O: CreateEnrollmentTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ListEnrollmentTokens
     */
    listEnrollmentTokens: {
      name: "ListEnrollmentTokens",
      I: ListEnrollmentTokensRequest,
      O: ListEnrollmentTokensResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ListDeviceEnrollments
     */
    listDeviceEnrollments: {
      name: "ListDeviceEnrollments",
      I: ListDeviceEnrollmentsRequest,
      O: ListDeviceEnrollmentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ClaimEnrollmentToken
     */
    claimEnrollmentToken: {
      name: "ClaimEnrollmentToken",
      I: ClaimEnrollmentTokenRequest,
      O: ClaimEnrollmentTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.RegisterDevice
     */
    registerDevice: {
      name: "RegisterDevice",
      I: RegisterDiagnosticsDeviceRequest,
      O: RegisterDiagnosticsDeviceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.UpsertRecordingPolicy
     */
    upsertRecordingPolicy: {
      name: "UpsertRecordingPolicy",
      I: UpsertRecordingPolicyRequest,
      O: UpsertRecordingPolicyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ListRecordingPolicies
     */
    listRecordingPolicies: {
      name: "ListRecordingPolicies",
      I: ListRecordingPoliciesRequest,
      O: ListRecordingPoliciesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.AssignRecordingPolicy
     */
    assignRecordingPolicy: {
      name: "AssignRecordingPolicy",
      I: AssignRecordingPolicyRequest,
      O: AssignRecordingPolicyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.GetEffectivePolicy
     */
    getEffectivePolicy: {
      name: "GetEffectivePolicy",
      I: GetEffectivePolicyRequest,
      O: GetEffectivePolicyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.StartRecordingSession
     */
    startRecordingSession: {
      name: "StartRecordingSession",
      I: StartRecordingSessionRequest,
      O: StartRecordingSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ReportRecordingHeartbeat
     */
    reportRecordingHeartbeat: {
      name: "ReportRecordingHeartbeat",
      I: ReportRecordingHeartbeatRequest,
      O: ReportRecordingHeartbeatResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.CompleteRecordingSession
     */
    completeRecordingSession: {
      name: "CompleteRecordingSession",
      I: CompleteRecordingSessionRequest,
      O: CompleteRecordingSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.UploadRecordingArtifact
     */
    uploadRecordingArtifact: {
      name: "UploadRecordingArtifact",
      I: UploadRecordingArtifactRequest,
      O: UploadRecordingArtifactResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ListRecordingSessions
     */
    listRecordingSessions: {
      name: "ListRecordingSessions",
      I: ListRecordingSessionsRequest,
      O: ListRecordingSessionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.SearchTimelineSegments
     */
    searchTimelineSegments: {
      name: "SearchTimelineSegments",
      I: SearchTimelineSegmentsRequest,
      O: SearchTimelineSegmentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.CreateStorageTarget
     */
    createStorageTarget: {
      name: "CreateStorageTarget",
      I: CreateStorageTargetRequest,
      O: CreateStorageTargetResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ListStorageTargets
     */
    listStorageTargets: {
      name: "ListStorageTargets",
      I: ListStorageTargetsRequest,
      O: ListStorageTargetsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.CreateReplayRequest
     */
    createReplayRequest: {
      name: "CreateReplayRequest",
      I: CreateReplayRequestRequest,
      O: CreateReplayRequestResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.UpdateReplayRequestStatus
     */
    updateReplayRequestStatus: {
      name: "UpdateReplayRequestStatus",
      I: UpdateReplayRequestStatusRequest,
      O: UpdateReplayRequestStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ListReplayRequests
     */
    listReplayRequests: {
      name: "ListReplayRequests",
      I: ListReplayRequestsRequest,
      O: ListReplayRequestsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.CreateExportJob
     */
    createExportJob: {
      name: "CreateExportJob",
      I: CreateExportJobRequest,
      O: CreateExportJobResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ListExportJobs
     */
    listExportJobs: {
      name: "ListExportJobs",
      I: ListExportJobsRequest,
      O: ListExportJobsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.HybridSearch
     */
    hybridSearch: {
      name: "HybridSearch",
      I: HybridSearchRequest,
      O: HybridSearchResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.VisualSimilaritySearch
     */
    visualSimilaritySearch: {
      name: "VisualSimilaritySearch",
      I: VisualSimilaritySearchRequest,
      O: VisualSimilaritySearchResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.GetTimeInApp
     */
    getTimeInApp: {
      name: "GetTimeInApp",
      I: GetTimeInAppRequest,
      O: GetTimeInAppResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.GetActivityTimeline
     */
    getActivityTimeline: {
      name: "GetActivityTimeline",
      I: GetActivityTimelineRequest,
      O: GetActivityTimelineResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.NaturalLanguageSearch
     */
    naturalLanguageSearch: {
      name: "NaturalLanguageSearch",
      I: NaturalLanguageSearchRequest,
      O: NaturalLanguageSearchResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.GetReplaySegments
     */
    getReplaySegments: {
      name: "GetReplaySegments",
      I: GetReplaySegmentsRequest,
      O: GetReplaySegmentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.GetLiveEmployees
     */
    getLiveEmployees: {
      name: "GetLiveEmployees",
      I: GetLiveEmployeesRequest,
      O: GetLiveEmployeesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.GetDiagnosticsHealth
     */
    getDiagnosticsHealth: {
      name: "GetDiagnosticsHealth",
      I: GetDiagnosticsHealthRequest,
      O: GetDiagnosticsHealthResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.RunBatchEmbedding
     */
    runBatchEmbedding: {
      name: "RunBatchEmbedding",
      I: RunBatchEmbeddingRequest,
      O: RunBatchEmbeddingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Activity segmentation reads (VLM-described activity blocks).
     *
     * @generated from rpc omnios.v1.DiagnosticsService.ListWorkspaceActivity
     */
    listWorkspaceActivity: {
      name: "ListWorkspaceActivity",
      I: ListWorkspaceActivityRequest,
      O: ListWorkspaceActivityResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ListActivitySegments
     */
    listActivitySegments: {
      name: "ListActivitySegments",
      I: ListActivitySegmentsRequest,
      O: ListActivitySegmentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ListActivityObservations
     */
    listActivityObservations: {
      name: "ListActivityObservations",
      I: ListActivityObservationsRequest,
      O: ListActivityObservationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.GetSegmentationCursor
     */
    getSegmentationCursor: {
      name: "GetSegmentationCursor",
      I: GetSegmentationCursorRequest,
      O: GetSegmentationCursorResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Ops actions.
     *
     * @generated from rpc omnios.v1.DiagnosticsService.ReaggregateSession
     */
    reaggregateSession: {
      name: "ReaggregateSession",
      I: ReaggregateSessionRequest,
      O: ReaggregateSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.DiagnosticsService.ResetSegmentationCursor
     */
    resetSegmentationCursor: {
      name: "ResetSegmentationCursor",
      I: ResetSegmentationCursorRequest,
      O: ResetSegmentationCursorResponse,
      kind: MethodKind.Unary,
    },
  }
};

